import { Component, OnChanges, Input, SimpleChanges } from '@angular/core';
import _ from 'lodash';

@Component({
  selector: 'signgaze-book-screen',
  templateUrl: './book-screen.component.html',
  styleUrls: ['./book-screen.component.scss'],
})
export class BookScreenComponent implements OnChanges {
  readonly taxRate: number = 18;
  segmentDimmed = true;
  isClickable = false;
  @Input()
  screenPrice: number;
  @Input()
  isUserSignedIn = false;
  @Input()
  isScreenAvailableForBooking = true;

  taxAmount: number;
  totalPrice: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['screenPrice']) {
      if (this.screenPrice) {
        this.calculateTax();
        this.calculateTotalPrice();
      }
    }
  }

  private calculateTax(): void {
    const taxAmount = (this.taxRate / 100) * this.screenPrice;
    this.taxAmount = +_.round(taxAmount, 2).toFixed(2);
  }

  private calculateTotalPrice(): void {
    this.totalPrice = +_.round(this.taxAmount + this.screenPrice, 2).toFixed(2);
  }
}
